module.exports = __webpack_public_path__ + "7ae4f41a6c28f3558817d5a5c7e8bd7a.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics1/6.png
// module id = 288
// module chunks = 0